import { NgModule } from "@angular/core";

import { ScrollModule } from "@intocare-medapp/ui";

import { HomeComponent } from "./home.component";
import { PatientOverviewComponent } from "./patient-overview/patient-overview.component";
import { PatientListComponent } from "./patient-list/patient-list.component";
import { PatientItemComponent } from "./patient-item/patient-item.component";
import { routing } from "./home.routing";
import { HomeGuard } from "./home.guard";
import { CallEventsComponent } from "./call-events/call-events.component";
import { ResidentsComponent } from "./residents/residents.component";
import { CallEventsOverviewComponent } from "./call-events-overview/call-events-overview.component";
import { CallEventItemComponent } from "./call-event-item/call-event-item.component";
import { CallEventListComponent } from "./call-event-list/call-event-list.component";
import { AnnouncementsComponent } from "./announcements/announcements.component";
import { BriefingModule } from "../briefing";
import { SharedModule } from "../shared/shared.module";

@NgModule({
	imports: [ScrollModule, SharedModule, BriefingModule],
	declarations: [
		HomeComponent,
		PatientOverviewComponent,
		PatientListComponent,
		PatientItemComponent,
		CallEventsComponent,
		ResidentsComponent,
		CallEventsOverviewComponent,
		CallEventItemComponent,
		CallEventListComponent,
		AnnouncementsComponent,
	],
	exports: [
		HomeComponent,
		PatientOverviewComponent,
		PatientListComponent,
		PatientItemComponent,
		CallEventsComponent,
		ResidentsComponent,
		CallEventsOverviewComponent,
		CallEventItemComponent,
		CallEventListComponent,
		AnnouncementsComponent,
	],
})
export class HomeSharedModule {}

@NgModule({
	imports: [ScrollModule, SharedModule, HomeSharedModule, routing, BriefingModule],
	providers: [HomeGuard],
})
export class HomeModule {}
